// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2CDXK","dragIcon":"Choice_dragIcon__2zI7Y","left":"Choice_left__1iSau","input":"Choice_input__H2NPK"};